export default __webpack_public_path__ + "static/media/sapir.4b316af4.svg";